(function() {
  function onReady(fn) {
    document.addEventListener("turbolinks:load", fn);
  }

  onReady(function initAddPages() {
    var form = document.querySelector("form#new_plan_amendment, form[action*='plan_amendments']");
    if (!form || form.dataset.addBound === "true") return;
    form.dataset.addBound = "true";

    var pdfFrame   = document.getElementById("addPdfFrame");
    var jumpInput  = document.getElementById("addJumpInput");
    var jumpBtn    = document.getElementById("addJumpBtn");
    var startField = document.getElementById("addStartPage");
    var hintEl     = document.getElementById("addHint");
    var summaryEl  = document.getElementById("addRangeSummary");
    var appendBtn  = document.getElementById("addAppendToEndBtn");

    var max = parseInt((form.dataset.pageCount || document.querySelector("#deletePagesForm")?.dataset.pageCount || "0"), 10);
    if (!max) {
      var m = (hintEl?.textContent || "").match(/1–(\d+)/);
      if (m) max = parseInt(m[1], 10);
    }

    // Prevent Enter from accidental submit (except textareas)
    form.addEventListener("keydown", function(e){
      if (e.key === "Enter" && e.target && e.target.tagName !== "TEXTAREA") {
        e.preventDefault(); e.stopPropagation();
      }
    });

    function viewPage(n) {
      n = parseInt(n, 10);
      if (!isNaN(n) && n >= 1 && max && n <= max) {
        if (window._addPagesViewer) {
          window._addPagesViewer.goToPage(n);
        } else if (pdfFrame) {
          var base = pdfFrame.src.split("#")[0];
          pdfFrame.src = base + "#page=" + n + "&zoom=page-fit";
        }
      }
    }

    if (jumpBtn) jumpBtn.addEventListener("click", function(){ viewPage(jumpInput && jumpInput.value); });
    if (jumpInput) jumpInput.addEventListener("keydown", function(e){
      if (e.key === "Enter") { e.preventDefault(); viewPage(jumpInput.value); }
    });

    if (appendBtn) appendBtn.addEventListener("click", function(){
      if (startField) startField.value = max;
      // select "after" radio
      var after = form.querySelector("input[name='plan_amendment[placement]'][value='after']");
      if (after) after.checked = true;
      viewPage(max);
      updateHints();
    });

    function updateHints() {
      var placement = form.querySelector("input[name='plan_amendment[placement]']:checked")?.value || "before";
      var start = parseInt(startField && startField.value, 10);
      var txt = "Range: 1–" + (max || "?") + ". Choose a page, then pick placement.";
      if (hintEl) hintEl.textContent = txt;

      if (!summaryEl) return;
      if (!start || isNaN(start)) { summaryEl.textContent = ""; return; }

      if (placement === "before") {
        summaryEl.textContent = "Will insert before page " + start + ".";
      } else if (placement === "after") {
        summaryEl.textContent = "Will insert after page " + start + ".";
      } else if (placement === "replace") {
        // We can’t know the new file's page count yet on the client; keep message simple.
        summaryEl.textContent = "Will replace pages starting at " + start + " (exact range shown after upload).";
      }
    }

    // React to placement or page changes
    form.querySelectorAll("input[name='plan_amendment[placement]']").forEach(function(r){
      r.addEventListener("change", updateHints);
    });
    if (startField) startField.addEventListener("input", function(){ updateHints(); viewPage(startField.value); });

    updateHints();
  });
})();
